import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-rental-custom-pickup-slot',
  templateUrl: './add-edit-rental-custom-pickup-slot.component.html',
  styleUrls: ['./add-edit-rental-custom-pickup-slot.component.scss'],
})
export class AddEditRentalCustomPickupSlotComponent implements OnInit {
  @Input() data;
  @Input() configuration;
  @Output() close = new EventEmitter();
  public days = [0, 1, 2, 3, 4, 5, 6];
  public saving: boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    if (this.data.id) {
      this.data.pickupTime = moment(
        '1970-01-01T' + this.data.pickupTime,
      ).toDate();
    }
  }

  isDayValid(day) {
    return (
      this.configuration &&
      this.configuration.defaultStoreTimes.filter((x) => {
        return x.dayOfWeek === day && x.isWorking;
      }).length > 0
    );
  }

  dayOfWeek(val) {
    switch (val) {
      case 0:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.sunday',
        );
      case 1:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.monday',
        );
      case 2:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.tuesday',
        );
      case 3:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.wednesday',
        );
      case 4:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.thursday',
        );
      case 5:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.friday',
        );
      case 6:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.saturday',
        );
    }
  }

  dayChanged() {
    if (
      !this.data.id &&
      this.configuration &&
      this.configuration.defaultStoreTimes
    ) {
      var defaultDay = this.configuration.defaultStoreTimes
        .filter((x) => {
          return x.dayOfWeek === this.data.dayOfWeek && x.isWorking;
        })
        .pop();
      if (defaultDay) {
        this.data.pickupTime = moment(defaultDay.startTime).toDate();
      }
    }
  }

  valid() {
    return (
      this.data.dayOfWeek >= 0 &&
      this.data.dayOfWeek < 7 &&
      this.data.pickupTime &&
      this.data.pickupTime >= this.getMinDate() &&
      this.data.pickupTime <= this.getMaxDate()
    );
  }

  save() {
    this.saving = true;
    var data = {
      ...this.data,
      pickupTime: moment(this.data.pickupTime).format('HH:mm'),
    };
    this.rentalsService.addOverridePickupSlot(data).subscribe(
      (res) => {
        this.saving = false;
        this.close.emit(res);
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  getMinDate(format: boolean = false) {
    if (this.data.dayOfWeek >= 0 && this.data.dayOfWeek <= 6) {
      var defaultDay = this.configuration.defaultStoreTimes
        .filter((x) => {
          return x.dayOfWeek === this.data.dayOfWeek && x.isWorking;
        })
        .pop();
      return format
        ? moment(defaultDay.startTime).format('HH:mma')
        : moment(defaultDay.startTime).toDate();
    } else {
      return format ? '00:00 am' : moment('1970-01-01T00:00:00').toDate();
    }
  }

  getMaxDate(format: boolean = false) {
    if (this.data.dayOfWeek >= 0 && this.data.dayOfWeek <= 6) {
      var defaultDay = this.configuration.defaultStoreTimes
        .filter((x) => {
          return x.dayOfWeek === this.data.dayOfWeek && x.isWorking;
        })
        .pop();
      return format
        ? moment(defaultDay.endTime).format('HH:mma')
        : moment(defaultDay.endTime).toDate();
    } else {
      return format ? '00:00 am' : moment('1970-01-01T00:00:00').toDate();
    }
  }
}
